import { render, staticRenderFns } from "./News_information.vue?vue&type=template&id=744ba05f&scoped=true&"
import script from "./News_information.vue?vue&type=script&lang=js&"
export * from "./News_information.vue?vue&type=script&lang=js&"
import style0 from "./News_information.vue?vue&type=style&index=0&id=744ba05f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744ba05f",
  null
  
)

export default component.exports